export const REPORT_STATUS = {
    Draft: { id: 1, textKey: 'Draft', styleKey: 'draft' },
    ToBeTranscribed: { id: 2, textKey: 'ToBeTranscribed', styleKey: 'toBeTranscribed' },
    Transcribed: { id: 3, textKey: 'Transcribed', styleKey: 'transcribed' },
    Preliminary: { id: 4, textKey: 'Preliminary', styleKey: 'preliminary' },
    Validated: { id: 5, textKey: 'Validated', styleKey: 'validated' },
    Dictating: { id: 6, textKey: 'Dictating', styleKey: 'dictating' },
} as const;

export type ReportStatus = (typeof REPORT_STATUS)[keyof typeof REPORT_STATUS];
export type ReportStatusId = ReportStatus['id'];

const REPORT_STATUS_BY_ID = Object.fromEntries(
    Object.values(REPORT_STATUS).map((status) => [status.id, status]),
) as Record<ReportStatusId, ReportStatus>;

const isReportStatusId = (status: number): status is ReportStatusId =>
    Object.hasOwn(REPORT_STATUS_BY_ID, status);

export const getReportStatusById = (status: number | null): ReportStatus | null => {
    if (status === null || !isReportStatusId(status)) {
        return null;
    }

    return REPORT_STATUS_BY_ID[status];
};

export const getReportStatusText = (status: number | null): string | null => {
    return getReportStatusById(status)?.textKey ?? null;
};
